import util from "../util/util";

export default class NewsService {
  addRecord(payload) {
    return util
      .sendApiRequest("/news", "POST", true, payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  }
  editRecord(payload) {
    return util.sendApiRequest("/news", "PUT", true, payload).then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  }
  listAll(data) {
    const activity = Object.keys(data).reduce((object, key) => {
      if (data[key] !== "") {
        object[key] = data[key];
      }
      return object;
    }, {});

    return util.sendApiRequest("/news/list", "POST", true, activity).then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  }

  deleteRecord(id) {
    return util.sendApiRequest("/news/" + id, "DELETE", true).then(
      (response) => {
        return response;
      },
      (error) => {
        throw new Error(error);
      }
    );
  }
  getDetails(id) {
    return util.sendApiRequest("/news/" + id, "Get", true).then(
      (response) => {
        return response;
      },
      (error) => {
        throw new Error(error);
      }
    );
  }
  listCount(condition) {
    return util
      .sendApiRequest("/news/newsCount", "POST", condition)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  }
}
